<template>
  <div v-if="!$store.getters.loading">
    <toolbar></toolbar>
    <div class="row">
      <dashboard v-if="onlyDesktop" class="spacer"></dashboard>
      <virtualApp></virtualApp>
    </div>
  </div>
</template>
<script>
import Toolbar from "../components/Home/Toolbar";
import Dashboard from "../components/Home/Dashboard";
import VirtualApp from "../components/Home/VirtualApp";
export default {
  components: {
    Toolbar,
    Dashboard,
    VirtualApp
  },
  computed: {
    onlyDesktop() {
      return window.innerWidth > 800;
    }
  }
};
</script>
